import styled, { css } from 'styled-components';
import IconCloseFilled from '../../assets/svgs/close-filled.svg';
import Theme from '../../theme';
import { remCalc } from '@lux/helpers';
export var layoutProps = {
  height: 40,
  padV: 8,
  padH: 12
};
export var IconButtonContainer = styled.div.withConfig({
  displayName: "styles__IconButtonContainer",
  componentId: "sc-y7x0ks-0"
})(["height:", ";width:", ";box-sizing:border-box;position:absolute;top:0;right:", ";padding:", ";"], remCalc(layoutProps.height), remCalc(layoutProps.height), function (props) {
  return props.stickyRight ? '40px' : '0px';
}, remCalc(layoutProps.padH));
export var IconButton = styled.div.withConfig({
  displayName: "styles__IconButton",
  componentId: "sc-y7x0ks-1"
})(["cursor:pointer;position:absolute;top:5%;left:5%;height:90%;width:90%;display:flex;align-items:center;justify-content:center;border-radius:2px;&:active{background:", ";}transition:background-color 100ms;"], Theme.colours.grey_e1);
export var CloseIcon = styled(IconCloseFilled).withConfig({
  displayName: "styles__CloseIcon",
  componentId: "sc-y7x0ks-2"
})(["fill:", ";", ":hover &{fill:", ";}"], Theme.colours.grey_c6,
/* sc-selector */
IconButton, Theme.colours.grey_70);
export var InputContainer = styled.div.withConfig({
  displayName: "styles__InputContainer",
  componentId: "sc-y7x0ks-3"
})(["position:relative;"]);
export var HintMessage = styled.div.withConfig({
  displayName: "styles__HintMessage",
  componentId: "sc-y7x0ks-4"
})(["font-family:", ";font-size:", ";margin:", " 0 ", ";color:", ";"], Theme.fonts.families.AvenirBook, Theme.fonts.sizes.small, remCalc(8), remCalc(16), function (props) {
  return props.validation ? Theme.states[props.validation].colour : Theme.colours.grey_c6;
});
export default {
  Input: styled.input.withConfig({
    displayName: "styles__Input",
    componentId: "sc-y7x0ks-5"
  })(["&&{font-family:", ";font-size:", ";", ";height:", ";border:", ";box-shadow:none;padding:", " ", ";", ";width:100%;margin:", ";color:", ";display:block;", ";&::placeholder{color:", ";font-size:", ";}&:focus{border-color:", ";outline:0;}}"], Theme.fonts.families.AvenirBook, Theme.fonts.sizes.regular, Theme.styles.componentSmallRadius, remCalc(layoutProps.height), function (props) {
    return props.validation ? "1px solid " + Theme.states[props.validation].colour : "1px solid " + Theme.colours.grey_c6;
  }, remCalc(layoutProps.padV), remCalc(layoutProps.padH), function (props) {
    return !props.showClear && !props.rightIcon ? null : css(["padding-right:", ";"], props.showClear && props.rightIcon ? remCalc(2 * layoutProps.height) : remCalc(layoutProps.height));
  }, function (props) {
    return props.hintMessage ? '0' : "0 0 " + remCalc(16) + " 0";
  }, Theme.colours.black, function (props) {
    return !props.isEditable ? css(["font-size:", ";border:none;padding:", " 0;color:", ";"], Theme.fonts.sizes.large, remCalc(8), Theme.colours.black) : css(["&.disabled,&[disabled]{background:", ";border:1px solid ", ";color:", ";cursor:default;transition:border-color 0.15s linear,background 0.15s linear;}"], Theme.colours.white, Theme.colours.grey_cc, Theme.colours.grey_cc);
  }, Theme.colours.grey_c6, remCalc(16), function (props) {
    return props.validation ? Theme.states[props.validation].colour : Theme.colours.linkblue;
  })
};